import React from "react"

import { useAppSelector } from "redux/hooks"
import { selectCode } from "redux/features/verification/verificationSlice"

export function withVerification<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithVerification = (props: GenericType) => {
    const code = useAppSelector((state) => selectCode(state)) || undefined

    return <WrappedComponent {...props} code={code} />
  }

  return WithVerification
}
